/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerStartTransferMutationRequest, TransfersControllerStartTransferMutationResponse, TransfersControllerStartTransfer400, TransfersControllerStartTransfer401, TransfersControllerStartTransfer403 } from "../../models/transfersController/TransfersControllerStartTransfer";

function getTransfersControllerStartTransferUrl() {
  const res = { method: 'POST', url: `/api/v1/transfers` as const }  
  return res
}

/**
 * @summary Start a new transfer
 * {@link /api/v1/transfers}
 */
export async function transfersControllerStartTransfer(data?: TransfersControllerStartTransferMutationRequest, config: Partial<RequestConfig<TransfersControllerStartTransferMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransfersControllerStartTransferMutationResponse, ResponseErrorConfig<TransfersControllerStartTransfer400 | TransfersControllerStartTransfer401 | TransfersControllerStartTransfer403>, TransfersControllerStartTransferMutationRequest>({ method : "POST", url : getTransfersControllerStartTransferUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}